import * as React from "react";
import {
  ExperienceTemplateRenderer,
  ExperienceTemplateRendererContextProvider,
  TemplateComponentProps,
} from "experience-template-renderer-react";
import { GridContainer } from "src/components/shared/GridContainer/GridContainer";
import { BlossomComponents } from "src/components/flexFramework/BlossomComponents/BlossomComponents";
import { BlossomComponent } from "src/components/flexFramework/domain/BlossomComponent";
import { blossomCodeSplitter } from "src/components/flexFramework/CodeSplitter/BlossomCodeSplitter";
import { ExtendedTemplateComponent } from "src/stores/ExperienceTemplateStore/typings";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

export const renderPath = (
  context: ExtendedContextStore,
  templateComponent: ExtendedTemplateComponent,
  blossomComponent?: BlossomComponent
) => {
  if (blossomComponent) {
    return <BlossomComponents wrapper={GridContainer} blossomComponent={blossomComponent} context={context} />;
  }

  if (templateComponent.children) {
    return (
      <ExperienceTemplateRendererContextProvider
        libraryKeyResolver={blossomCodeSplitter.experienceTemplateLibraryKeyResolver}
        library={blossomCodeSplitter.componentLibrary}
        wrapper={GridContainer as React.ComponentType<TemplateComponentProps>}
      >
        <ExperienceTemplateRenderer templateComponents={templateComponent.children} />
      </ExperienceTemplateRendererContextProvider>
    );
  }

  return null;
};
